<template>
    <div class="users-style">

      <h4 class="atlhr-dashboard-title mt-10 px-0 mb-0">Leave & Attendance Settings<span>
          <a v-bind:href="$api_url+'/company/dashboard'">Dashboard</a> / Settings / Leave & Attendance Settings / Attendance Mobility</span>
      </h4>


        <div class="ibox px-3 py-4 mt-4">
          <div class="ibox-title dashboard_title company-form-box-title pf-contribution pl-0 pt-0 pb-0 roster-ibox">
            <h4 class="clearfix mb-0">
              <span class="float-left">Attendance Mobility
                  <span class="title-sub-text"></span>
              </span>
              <span class="float-right"></span>
            </h4>
          </div>
          <div class="clearfix row py-2 mb-2">
            <div class="col-sm-6">
              <div class="custom-search w-100">
                <b-input-group class="mb-0">
                  <b-input-group-prepend is-text>
                    <b-icon icon="search"></b-icon>
                  </b-input-group-prepend>
                  <b-form-input type="search" placeholder="Search.." v-model="search" @input="resetPagination()"></b-form-input>
                </b-input-group>
              </div>
            </div>
            <div class="col-sm-6 float-right text-right">
              <b-button id="show-btn" class="" @click="addNew(false)">+ Add Mobility Type</b-button>
            </div>
          </div>

          <div class="row justify-content-center">
            <div class="col-sm-12">
              <b-modal id="bv-modal-mobility" size="md" hide-footer :title="(fdata.id == null ? 'Add':'Edit') + ' Attendance Mobility Type'">
                <b-overlay :show="showoverlay" rounded="sm">

                  <template>
                    <b-form @submit.stop.prevent="onSubmit">
                      <div class="clearfix">
                        <div class="px-3">
                          <input type="hidden" v-model="fdata.id" name="id">

                          <div class="row">
                            <div class="col-sm-12">
                              <b-form-group  id="location-group" label="Type" class="required-field" label-for="location">
                                <b-input-group>
                                  <b-form-input id="location" class="radius-8" name="location" v-model="fdata.location" v-validate="{ required: true, min: 3 }" :state="validateState('location')" aria-describedby="location-feedback" data-vv-as="Type"></b-form-input>
                                  <b-form-invalid-feedback id="location-feedback">{{ veeErrors.first('location') }}</b-form-invalid-feedback>
                                </b-input-group>
                              </b-form-group>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-sm-6">
                              <b-form-group  id="max_hit_based_on-group" label="Based On" class="required-field" label-for="max_hit_based_on">
                                <b-form-select id="max_hit_based_on" :options="hit_options" name="max_hit_based_on" v-model="fdata.max_hit_based_on"></b-form-select>
                              </b-form-group>
                            </div>
                            <div class="col-sm-6">
                              <b-form-group  id="max_hit-group" :label="'Maximum Use Per ' + hit_options_str[fdata.max_hit_based_on].text" class="required-field" label-for="max_hit">
                                <b-input-group>
                                  <b-form-input id="max_hit" class="radius-8" name="max_hit" v-model="fdata.max_hit" v-validate="{ required: true, min_value: 1, max_value: hit_options_str[fdata.max_hit_based_on].range, numeric: true, }" :state="validateState('max_hit')" aria-describedby="max_hit-feedback" data-vv-as="Maximum Use Limit"></b-form-input>
                                  <b-form-invalid-feedback id="max_hit-feedback">{{ veeErrors.first('max_hit') }}</b-form-invalid-feedback>
                                </b-input-group>
                              </b-form-group>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-sm-12 approve-level-content py-0 px-3">
                                <div class="d-flex flex-row justify-content-between align-items-center mb-2">
                                    <div>
                                        <p class="salary-heads my-2">Allow User to Specify</p>
                                    </div>
                                    <div>
                                        <b-form-checkbox class="roster-small-switch" id="allow_specify" v-model="fdata.allow_specify" size="lg" name="allow_specify" switch :value="1" :unchecked-value="0"/>
                                    </div>
                                </div>
                            </div>

                          </div>
                          <div class="row">
                            <div class="col-sm-12">
                              <b-form-group label="Status">
                                <b-form-select v-model="fdata.status" :options="[{ value: 1, text: 'Enabled' }, { value: 0, text: 'Disabled' }]"></b-form-select>
                              </b-form-group>
                            </div>
                          </div>

                          <div class="full-width my-4 text-center">
                            <b-button type="submit" v-if="fdata.id" variant="primary" >Update</b-button>
                            <b-button type="submit" v-else variant="primary" >Save</b-button>
                            <b-button class="ml-2 custom-wizard-btn" @click="$bvModal.hide('bv-modal-mobility')" variant="primary">Cancel</b-button>
                            <b-button class="ml-2 custom-wizard-btn" @click="resetForm()">Reset</b-button>
                          </div>



                        </div>
                      </div>
                    </b-form>

                  </template>
                </b-overlay>
              </b-modal>

            </div>


            <div class="col-sm-12">
              <b-overlay :show="showoverlay_list" rounded="sm">
                <table class="table dataTable">
                  <thead>
                  <tr class="table-head">
                    <td class="pl-5">#</td>
                    <td>Type Name</td>
                    <td>Based On</td>
                    <td>Maximum Use Limit</td>
                    <td>Allow User to Specify</td>
                    <td>Status</td>
                    <td>Action</td>
                  </tr>
                  </thead>
                  <tbody>
                  <tr class="hover-bg table-row mx-2" v-for="(location , n) in paginatedData" :key="location.id">
                    <td>{{n+1}}</td>

                    <td>{{location.location}}</td>
                    <td>{{hit_options_str[location.max_hit_based_on].text}}</td>
                    <td>{{location.max_hit}}</td>
                    <td>{{location.allow_specify == 1 ? 'Yes':'No'}}</td>
                    <td>{{location.status == 1 ? 'Enabled':'Disabled'}}</td>

                    <td>
                      <div class="float-right mr-2 position-relative">
                        <b-button-toolbar>
                          <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>
                          <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                            <b-button-group class="mr-0">
                              <b-button variant="outline-secondary" @click="editLocation(location.id)">
                                <b-icon icon="pencil" aria-hidden="true" ></b-icon>Edit
                              </b-button>
                              <b-button variant="outline-danger" @click="deleteLocation(location.id)">
                                <b-icon icon="trash" aria-hidden="true"></b-icon>Delete
                              </b-button>
                            </b-button-group>
                          </div>
                        </b-button-toolbar>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
                <div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell">No Result Found!</div>
                <div v-else class="px-3">
                  <ul class="pagination b-pagination float-left mb-0 mt-1">
                    <li class="page-item disabled m-2">View</li>
                    <li class="page-item disabled"><b-form-select v-model="temp_length" :options="length_options" @change="setFirstPage()"></b-form-select></li>
                    <li class="page-item disabled m-2">per page. Total {{people}} records found.</li>
                  </ul>
                  <b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" base-url="#" prev-text="Previous" next-text="Next" first-number last-number ></b-pagination-nav>

                </div>

              </b-overlay>
            </div>

          </div>

        </div>


    </div>
</template>


<script>
export default{
    props: ['ce_flg' , 'check_ce' , 'flg'],
    data(){

        return {
          approver_types:[{
            value: 'sequential',
            text: 'Sequential Approval',
          },{
            value: 'anyone',
            text: 'Any-one Approval',
          },],
          attendance_approver_type: 'sequential',
          attendance_mobility_hierarchy: 0,
            mobilities:[],
            errormsg:[],
            fdata: {location:null , allow_specify:0, status: 1,max_hit:0, max_hit_based_on:0},
            saved_name : '',
            showoverlay:false,
            showoverlay_list:false,
            finish : false,
            search:'',
            length: 20,
            temp_length:20,
            hit_options_str: [{
              range:7,
              text:'Weekly',
            },{
              range:31,
              text:'Monthly',
            },{
              range:92,
              text:'Quartarly',
            },{
              range:365,
              text:'Yearly',
            },],
            hit_options:[{
              value:0,
              text: 'Weekly',
            },{
              value:1,
              text: 'Monthly',
            },{
              value:2,
              text: 'Quartarly',
            },{
              value:3,
              text: 'Yearly',
            },],
            length_options:
                [
                    { value: 20, text: "20" },
                    { value: 50, text: "50" },
                    { value: 100, text: "100" }
                ],
            people:0,
            pagination: {currentPage: 1, pages:1},
            successmsg:false,
            warningmsg:false,
            dangermsg:false,
            attendance_mobility:0,
            attendance_mobility_approver:0,
        }
    },
    methods:{


        showMessage: function()
        {
            let tmp_flg = 0;
            if(this.mobilities.length > 0)tmp_flg = 1;
            let childdata = {flg:tmp_flg , successmsg:this.successmsg , warningmsg:this.warningmsg , dangermsg:this.dangermsg,  move_next:this.go_next , move_back:this.go_back , finish:this.finish};
            this.$emit('childToParent', childdata);
        },
        addNew()
        {
            this.resetForm();
            this.$bvModal.show('bv-modal-mobility');
        },
        getData: function()
        {
            if(!this.checkNet()) return false;
            let currentObj = this;
            axios.get(this.$api_url+'/leave-attendance/attendance-mobility').then(function(response){
                this.mobilities = response.data;
                this.people = this.mobilities.length;

            }.bind(this)).catch(function (error){currentObj.serverError(error);});
        },

        editLocation:function(x)
        {
          const location = this.mobilities.find(el => el.id == x)
          this.fdata.id = location.id
          this.fdata.allow_specify = location.allow_specify
          this.fdata.status = location.status
          this.fdata.location = location.location
          this.fdata.max_hit = location.max_hit
          this.fdata.max_hit_based_on = location.max_hit_based_on
          this.$bvModal.show('bv-modal-mobility');
        },


        deleteLocation:function(x)
        {
            if(!this.checkNet()) return false;
            this.$bvModal.msgBoxConfirm('Please confirm that you want to delete this mobility location.', {
                title: 'Please Confirm', size: 'sm', buttonSize: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'Cancel', footerClass: 'p-2', hideHeaderClose: false,centered: true
            })
                .then(value => {
                    if(value)
                    {
                        this.resetForm();
                        let currentObj = this;
                        this.showoverlay_list = true;
                        let formData = new FormData();
                        formData.append('id', x);

                        axios.post(this.$api_url+'/leave-attendance/attendance-mobility/delete', formData).then((response)=>{
                          if(response.data.error){
                            this.$bvToast.toast(response.data.message, {
                              title: `Failed`,
                              variant: 'danger',
                              solid: true
                            });
                          }
                          else
                          {
                            this.$bvToast.toast('Deleted', {
                              title: `Success`,
                              variant: 'success',
                              solid: true
                            });
                            this.mobilities = response.data;
                            this.resetPagination();
                          }
                          this.showoverlay_list = false;

                        })
                            .catch(function (error)
                            {
                                currentObj.serverError(error);
                            });
                    }
                })
                .catch(err => {
                    // An error occurred
                })
        },
        validateState(ref)
        {
            if (
                this.veeFields[ref] &&
                (this.veeFields[ref].dirty || this.veeFields[ref].validated)
            ) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
        resetForm()
        {
            this.fdata = {location:'', allow_specify:0, status:0, max_hit: 0, max_hit_based_on: 0};

        },
        onSubmit(e)
        {
            if(!this.checkNet()) return false;
            this.warningmsg = null;
            this.successmsg = null;
            this.$validator.validateAll().then(result => {
                if (!result) {
                    return;
                }
                e.preventDefault();
                let currentObj = this;

                let formData = new FormData();
                this.showoverlay_list = true;

                for (let [key, value] of Object.entries(this.fdata))
                {
                    var nm = `${key}`;
                    var fval = `${value}`;
                    formData.append(nm, fval);
                }
                this.$bvModal.hide('bv-modal-mobility');

                axios.post(this.$api_url+'/leave-attendance/attendance-mobility/save', formData)
                    .then( (response)=>
                    {
                        this.mobilities = response.data.data;
                        this.people = this.mobilities.length

                        this.successmsg = 'Saved!';
                        if(response.data.code == 200)
                        {
                          this.$bvToast.toast(response.data.message, {
                              title: `Success`,
                              variant: 'success',
                              solid: true
                          });
                        }
                        else if(response.data.code == 422)
                        {
                            this.$bvToast.toast(response.data.message, {
                              title: `Warning`,
                              variant: 'warning',
                              solid: true
                          });
                        }
                        this.showoverlay_list = false;
                        this.resetForm();

                    })
                    .catch(function (error)
                    {
                        currentObj.serverError(error);                        
                    });
            });
        },

    },
    created: function(){
        this.getData();
        Fire.$on('reloadUsers', () => {this.getData()});
    },
    computed:
        {
            filteredData()
            {
                let filtered_list = this.mobilities;
                if (this.search)
                {
                    filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});
                }
                return filtered_list;
            },
            paginatedData()
            {
                return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
            }
        }
}
</script>
